import React from "react";
import PropTypes from "prop-types";
import { Box, Flex, Image, Text, useMantineTheme } from "@mantine/core";
import { useStylesLanding } from "../../utils/mantine/useStylesLanding";
import CustomAnchor from "../mantineCustomComponents/CustomAnchor";
import { useStylesButton } from "../../utils/mantine/useStylesButton";

const TransformDataSecurity = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: landingClasses } = useStylesLanding();
  const { classes: buttonClasses } = useStylesButton();
  return (
    <Box component="section" className={landingClasses.transformDataSecurity}>
      <Box className={landingClasses.landingContainer}>
        <Flex
          align={theme.flex.align.center}
          className={landingClasses.transformDataSecurityBlocks}
        >
          <Box className={landingClasses.transformDataSecurityBlocksTexts}>
            <Text component="span">
              Transform Your Data Security with vBase
            </Text>
            <Text>
              Establishes the exact time of digital record creation, providing a
              dependable and unchangeable history of events.
            </Text>
            <Flex
              align={theme.flex.align.center}
              className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
            >
              <CustomAnchor
                text="Begin Today"
                target="_blank"
                href="/accounts/signup/"
                IconChevronRightLandingEnable="true"
                componentClasses={`${buttonClasses.buttonWhite} ${landingClasses.pricingBlockButtonsButton} ${landingClasses.supplementaryInformationButton}`}
              />
            </Flex>
          </Box>
          <Box className={landingClasses.transformDataSecurityBlocksTextsImg}>
            <Image
              src={`${staticBasePath}public/images/svg/landing_transform_data_security.svg`}
              alt="Transform Your Data Security with vBase"
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
TransformDataSecurity.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
};
export default TransformDataSecurity;
